import React, { FC, useEffect } from 'react';
import { View } from 'native-base';

type Props = {
  setFormField: (id: string, value: string) => void;
};

const TEST_SITEKEY = '1x00000000000000000000AA';
const PRODUCTION_SITEKEY = '0x4AAAAAAAzBnc0JoY_pWuzi';

export const FormFieldTurnstile: FC<Props> = ({ setFormField }) => {
  useEffect(() => {
    // @ts-ignore
    turnstile.render('#turnstile', {
      sitekey: window.location.hostname === 'localhost' ? TEST_SITEKEY : PRODUCTION_SITEKEY,
      theme: 'light',
      callback: (token: string) => {
        setFormField('turnstile', token);
      },
    });
  }, []);

  return <View nativeID={'turnstile'} />;
};
